import React from 'react';
import { Button } from './common/Button';
import { CheckIcon, ShoppingBagIcon } from 'lucide-react';
export function SplitSection() {
  const shopperBenefits = ['Automatic rewards at your local spots', 'No coupon codes to search when shopping', 'Discover new local favorites', 'Special perks for loyal customers', 'Share with friends for bonus perks'];
  const merchantBenefits = ['No hardware or special equipment needed', 'Works with your existing payment system', 'Detailed customer insights dashboard', 'Customizable reward programs', 'Increase repeat customer visits'];
  const brandBenefits = ['Sponsor in-store perks', 'Run Drops for new products & offers', 'Personalised perks for repeat buyers', 'Activate underperforming stores', 'Turn cafés into sampling channels'];
  return <div className="bg-white" data-id="element-525">
      {/* Merchants Section */}
      <section id="merchants" className="py-24 bg-[#F9F9F6] border-b border-gray-100" data-id="element-526">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-527">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-528">
            <div className="lg:w-1/2" data-id="element-529">
              <div className="inline-block bg-[#1A1A1A] px-4 py-1 rounded-full text-sm font-bold text-white mb-6" data-id="element-530">
                FOR MERCHANTS
              </div>
              <h2 className="text-4xl sm:text-5xl font-black mb-8 text-[#1A1A1A] uppercase tracking-tight" data-id="element-531">
                Grow Your Business
              </h2>
              <ul className="space-y-4 mb-10" data-id="element-532">
                {merchantBenefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-533">
                    <div className="bg-[#FFFC00] rounded-full p-1.5 mr-4 mt-1 flex-shrink-0 border border-[#1A1A1A]" data-id="element-534">
                      <CheckIcon className="h-4 w-4 text-[#1A1A1A] stroke-[3]" data-id="element-535" />
                    </div>
                    <span className="text-xl text-gray-700 font-medium" data-id="element-536">
                      {benefit}
                    </span>
                  </li>)}
              </ul>
              <Button variant="outline" size="lg" href="https://kraya.shop/" data-id="element-537">
                Partner With Us
              </Button>
            </div>
            <div className="lg:w-1/2" data-id="element-538">
              <div className="relative aspect-square" data-id="element-539">
                <div className="absolute inset-0 bg-[#1A1A1A] rounded-[3rem] transform -translate-x-4 translate-y-4" data-id="element-540"></div>
                <img src="https://cdn.magicpatterns.com/uploads/fxQHPTQDeoT5H44M7fgzzE/1d79ecf3086084ff597ef63c5ec6c04c.jpg" alt="Weekend café exterior" className="absolute inset-0 w-full h-full object-cover rounded-[3rem] border-4 border-[#1A1A1A] bg-white" data-id="element-541" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Shoppers Section */}
      <section id="shoppers" className="py-24" data-id="element-542">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-543">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-544">
            <div className="lg:w-1/2 order-2 lg:order-1" data-id="element-545">
              <div className="relative aspect-square" data-id="element-546">
                <div className="absolute inset-0 bg-[#1A1A1A] rounded-[3rem] transform translate-x-4 translate-y-4" data-id="element-547"></div>
                <img src="https://cdn.magicpatterns.com/uploads/oSnyo2cVrZMg8UMHRtjE85/sxy.jpg" alt="Shopper using rewards app" className="absolute inset-0 w-full h-full object-cover rounded-[3rem] border-4 border-[#1A1A1A] bg-white" data-id="element-548" />
              </div>
            </div>
            <div className="lg:w-1/2 order-1 lg:order-2" data-id="element-549">
              <div className="inline-block bg-[#FFFC00] border-2 border-[#1A1A1A] px-4 py-1 rounded-full text-sm font-bold text-[#1A1A1A] mb-6" data-id="element-550">
                FOR SHOPPERS
              </div>
              <h2 className="text-4xl sm:text-5xl font-black mb-8 text-[#1A1A1A] uppercase tracking-tight" data-id="element-551">
                Earn While You Spend
              </h2>
              <ul className="space-y-4 mb-10" data-id="element-552">
                {shopperBenefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-553">
                    <div className="bg-[#1A1A1A] rounded-full p-1.5 mr-4 mt-1 flex-shrink-0" data-id="element-554">
                      <CheckIcon className="h-4 w-4 text-[#FFFC00] stroke-[3]" data-id="element-555" />
                    </div>
                    <span className="text-xl text-gray-700 font-medium" data-id="element-556">
                      {benefit}
                    </span>
                  </li>)}
              </ul>
              <Button variant="primary" size="lg" href="https://kraya.live/" data-id="element-557">
                Join Waitlist
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>;
}